module.exports = __webpack_public_path__ + "img/about-company-02.98a45b47.webp";